interface ComboboxJobItemProps {
  job: { id: number; title: string; aggregates?: { highPriority?: number } };
}
export function ComboboxJobItem({ job }: ComboboxJobItemProps) {
  const isHighPriority = job.aggregates?.highPriority === 1;

  return (
    <div className="flex w-full justify-between gap-2">
      <div className="flex-1">{job.title}</div>
      {isHighPriority && <img alt="" src="/images/flame.svg" className="h-4 w-4 shrink-0" />}
    </div>
  );
}
